// The "no learner on this account" screen. Renders the pressed reader's-card
// modal (CreateLearnerModal, a fullscreen portal) scoped to THIS component's
// lifetime — so when a learner is created or restored, activeLearner becomes
// set, ModuleRouter unmounts this, and the modal disappears with it. Nothing
// can get stuck open. Replaces the old generic-Tailwind CreateLearnerPrompt
// (deleted 2026-07-14) so Home, Books, and Book detail all default to the
// new design.
//
// Deliberately does NOT toggle the shared `addLearnerOpen` store flag: that
// is a sticky global that a stray render could leave open behind an existing
// learner (the 2026-07-14 regression). At zero learners CreateLearnerModal
// hides "Save & exit", so this is correctly a wall with no dismiss.

import { CreateLearnerModal } from '@/components/domain/CreateLearnerModal'

export function AddLearnerEmptyState() {
  return <CreateLearnerModal isOpen onClose={() => {}} />
}
